<template>
  <advanced-check-box-filter-modal
    @close="$emit('close')"
    @validate="v => $emit('validate', v)"
    :checked="checked"
    :checkBoxValues="checkBoxValues"
    :title="$t('views.government.vote.votes')"
  />
</template>

<script>
import AdvancedCheckBoxFilterModal from "./AdvancedCheckBoxFilterModal.vue";
import { VoteMixin } from "@/utils/VoteMixin";

export default {
  name: "DecisionFilterModal",
  components: {
    AdvancedCheckBoxFilterModal
  },
  props: {
    checked: {
      type: Array
    }
  },
  computed: {
    checkBoxValues() {
      const participated = ["Yes", "No", "EH"];
      const not = Object.keys(this.allVotes).filter(
        k => !participated.includes(k)
      );
      return [
        {
          title: this.$t("components.modals.decision.participated"),
          values: participated.map(k => ({
            value: k,
            label: this.allVotes[k]
          }))
        },
        {
          title: this.$t("components.modals.decision.not_participated"),
          values: not.map(k => ({
            value: k,
            label: this.allVotes[k]
          }))
        }
      ];
    }
  },
  mixins: [VoteMixin]
};
</script>
